module.exports = {
    title: 'holden',
    env_title:'holden',//token信息会从此处取名称
    fixedHeader: true,
    sidebarLogo: true
  }
  